import Icon from '@components/officialTopup/common/Icon.vue';
import Select from '@components/officialTopup/common/Select.vue';
import Button from '@components/officialTopup/common/Button.vue';
import SelectGroup from '@components/officialTopup/common/SelectGroup.vue';
import PopupWindow from '@components/officialTopup/common/PopupWindow.vue';
import DataList from '@components/officialTopup/common/DataList.vue';
import Tabbar from '@components/officialTopup/common/Tabbar.vue';
import GiftIcon from '@components/officialTopup/common/GiftIcon.vue';

export default {
  install(Vue) {
    Vue.component('Icon', Icon);
    Vue.component('Select', Select);
    Vue.component('Button', Button);
    Vue.component('SelectGroup', SelectGroup);
    Vue.component('PopupWindow', PopupWindow);
    Vue.component('DataList', DataList);
    Vue.component('Tabbar', Tabbar);
    Vue.component('GiftIcon', GiftIcon);
  }
}; 
